import React from 'react'
import css from './detailsStyle.scss'

const Details = ({ details }) => <div className={css.details}>{details.filter(Boolean).join(' | ')}</div>

export default Details
